// extracted by mini-css-extract-plugin
export default {"container":"Cv-z","brandName":"Dv-z","productName":"Ev-z","productNamePdpEnhancements":"Fv-z","breakLongProductName":"Gv-z"};